import { getS3url_campPhoto, getS3url_reviewImg } from "./s3_api";


//uploads image in formData to s3 at specified url
async function sendImgToSignedURL(url:string,formData:FormData):Promise<Function>{
	return new Promise(function(resolve, reject) {
		let xhr = new XMLHttpRequest();
		xhr.open("POST",url,true);
		xhr.onreadystatechange = function(){
			if (this.status >= 200 && this.status < 300) {
				resolve(xhr.response);
			} else {
				reject({
					status: this.status,
					statusText: xhr.statusText
				})
			};
		};
		xhr.onerror = function() {
			reject({
				status: this.status,
				statusText: xhr.statusText
			})
		};
		xhr.send(formData);
	});
};

/*
 * requests server for presigned post to upload specified image for specified review
 * if gets presigned post, sends image to s3
 */
export async function uploadReviewImg(file:File,reviewID:string):Promise<string> {
	let imagePath:string | null = null;
	let signedURL:string | null = null;
	let formData:FormData = new FormData;

	await getS3url_reviewImg(file.name,reviewID).then((result) => {
		Object.keys(result.fields).forEach(key => {
			formData.append(key,result.fields[key]);
		});
		formData.append("file",file, file.name);
		formData.set("Content-Type",file.type);

		signedURL = result.url;

		imagePath = result.fields.key;
	}).catch(e => {
		const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
		$("#errorModal").modal("show");
	});
	if (signedURL != null) {
		await sendImgToSignedURL(signedURL,formData);
	} else {
		return null;
	};

	return imagePath;
};

export async function uploadCampPhotos(files:FileList | null, campID:string | undefined, campName:string | undefined):Promise<Array<string>> {
	let imagePaths:Array<string> | null = null;
	let signedURLs:Array<string> | null = null;

	if (files) {
		for (let i:number = 0; i < files.length; i++) {
			let formData:FormData = new FormData;
			//if campID is defined
			if(campID != undefined) {
				await getS3url_campPhoto(files[i].name,campID,undefined).then(async (result) => {
					Object.keys(result.fields).forEach(key => {
						formData.append(key,result.fields[key]);
					});
					formData.append("file",files[i], files[i].name);
					formData.set("Content-Type",files[i].type);
					signedURLs?.push(result.url);
					imagePaths?.push(result.fields.key);

					if (result.url != null) {
						await sendImgToSignedURL(result.url,formData).then(

						).catch(e => {
							console.error(e);
							const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
							$("#errorModal").modal("show");
						});
					}
				}).catch(e => {
					console.error(e);
					const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
					$("#errorModal").modal("show");
				});
			} else if (campName != undefined) {
				await getS3url_campPhoto(files[i].name,undefined,campName).then(async (result) => {
					Object.keys(result.fields).forEach(key => {
						formData.append(key,result.fields[key]);
					});
					formData.append("file",files[i], files[i].name);
					formData.set("Content-Type",files[i].type);
					signedURLs?.push(result.url);
					imagePaths?.push(result.fields.key);

					if (result.url != null) {
						await sendImgToSignedURL(result.url,formData).then(

						).catch(e => {
							console.error(e);
							const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
							$("#errorModal").modal("show");
						});
					}
				}).catch(e => {
					console.error(e);
					const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
					$("#errorModal").modal("show");
				});
			}
		}
		return imagePaths;
	}	else {
		return null;
	};
}